module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
      props: {
        width: 80,
      },
    },
    {
      name: '标题名称',
      value: 'name',
    },
    {
      name: '操作',
      value: '',
      props: {
        width: 180,
      },
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'primary',
                },
                on: {
                  click: () => {
                    s.onEdit(row, row.id);
                  },
                },
              },
              '编辑'
            ),
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'danger',
                },
                on: {
                  click: () => {
                    s.onDelete({
                      source_ids: [row.id],
                      rows: [row],
                      is_batch: false,
                    });
                  },
                },
              },
              '删除'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
